import React, { FC, useRef, useState } from 'react';

import { message } from 'antd';
import cn from 'classnames';
import { cloneDeep } from 'lodash';
import Link from 'next/link';
import { useRouter } from 'next/router';

import type { AirdropHistoryItem } from '@api/index';
import {
  openAirdrop,
  openAirdropCheck
} from '@api/index';
import { ImgShadow } from '@components/ImgShadow';
import { AIRDROP_PATHS } from '@constants/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks';
import pubsub from '@lib/scripts/pubsub'
import { I18n } from '@utils/index';
import { AirCard, AirdropEmpty, openActiveModal } from '@widget/airdrop';
import { airdropReceiveStatus } from '@widget/airdrop/constants';
// import { Button } from '@element/Button';
import { openOverdueModal } from '@widget/airdrop/Modal/OverdueModal';

import { useClaimHistory } from './hooks';

import styles from './index.module.less';
export const MeCardList: FC<{fetchData: () => void}> = (props) => {
  const { fetchData } = props;
  const { claimHistoryData, fetchClaimHistory } = useClaimHistory();
  const ref = useRef<HTMLDivElement>();
  const router = useRouter();
  const [num, setNum] = useState<number>(0);
  // const [active, setActive] = useState<boolean>(false);
  const [claimedAirdropList, setClaimedAirdropList] = useState<
    AirdropHistoryItem[]
  >([]);
  // 打开空投前校验
  const getAirdropCheck = async (id: string) => {
    const res = await openAirdropCheck({ id });
    if (!res.success) {
      message.error(I18n.t(res.msgKey));
      return;
    }
    return true;
  };
  // 打开空投
  const getAirdrop = async (item) => {
    const result = await getAirdropCheck(item.receiveId);
    const res = result && (await openAirdrop({ id: item?.receiveId }));
    if (!res) {
      return;
    }
    if (!res.success) {
      message.error(I18n.t(res.msgKey));
      return;
    }
    const modal = await openActiveModal({
      el: ref.current,
      name: item.cover,
      money: item.amount,
      coinCode: item.currency
    });
    fetchData();
    fetchClaimHistory();
    console.log('propsModal', modal);
  };
  // 过期空投处理
  const handlePressExpiredAirdrop = (receiveId: string, releaseNickName: string) => {
    openAirdrop({ id: receiveId });
    openOverdueModal({
      el: ref.current,
      name: releaseNickName,
      router: router
    })
    const newClaimedAirdropList = cloneDeep(claimedAirdropList).filter(
      (item: AirdropHistoryItem) => item.receiveId !== receiveId
    );
    setNum(num - 1);
    setClaimedAirdropList(newClaimedAirdropList);
  };
  // 点击空投卡片
  const turnOn = (item) => {
    if (item.status === airdropReceiveStatus.expired) {
      handlePressExpiredAirdrop(item.receiveId, item.releaseNickName);
    } else if (item.status === airdropReceiveStatus.noActive) {
      getAirdrop(item);
    }
  };
  // const onClick = () => {
  //   console.log('11111111ref.current', ref.current.children[0]);
  //   ref.current.children[0].style.setProperty?.('--position-left--', '120px');
  //   ref.current.children[0].style.setProperty?.('--position-top--', '347px');
  //   // ref.current.children[1].style.setProperty?.('--position-left--', '120px');
  //   // ref.current.children[1].style.setProperty?.('--position-top--', '347px');
  //   // ref.current.children[2].style.setProperty?.('--position-left--', '120px');
  //   // ref.current.children[2].style.setProperty?.('--position-top--', '347px');
  //   // ref.current.children[3].style.setProperty?.('--position-left--', '120px');
  //   // ref.current.children[3].style.setProperty?.('--position-top--', '347px');
  //   // ref.current.children[4].style.setProperty?.('--position-left--', '120px');
  //   // ref.current.children[4].style.setProperty?.('--position-top--', '347px');
  //   setActive(true);
  // };

  useIsomorphicLayoutEffect(() => {
    fetchClaimHistory();
    pubsub.subscribe('UPDATA_CLAIM_HISTORY', fetchClaimHistory);
    return () => {
      pubsub.unSubscribe('UPDATA_CLAIM_HISTORY', fetchClaimHistory);
    }
  }, []);
  useIsomorphicLayoutEffect(() => {
    const newReceiveList = claimHistoryData?.receiveList
      .filter((item) => [airdropReceiveStatus.noActive, airdropReceiveStatus.expired].includes(item.status));
    setNum(newReceiveList?.length);
    setClaimedAirdropList(claimHistoryData?.receiveList);
  }, [claimHistoryData]);
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.desc}>{I18n.t('augvkISj')}<ImgShadow
            className={styles.icon}
            width={46}
            height={40}
            src={require('@images/airdrop/question.webp')}
          />
          <span className={cn(styles.num)}> ({num})</span>
        </div>
        <div className={styles.link}>
          <Link legacyBehavior href={`${AIRDROP_PATHS.HISTORY}`}>
            <a>{I18n.t('pQgwmvRc')}</a>
          </Link>
        </div>
      </div>
      <div className={cn(styles.airBox)} ref={ref}>
        {/* <span
          className={cn('box1', {
            [styles.activeAirBox]: active
          })}
        >
          0
        </span> */}
      </div>
      {/* <Button type={'primary'} onClick={onClick}>
        点击
      </Button> */}
      <div className={styles.list}>
        {claimedAirdropList?.length ? (
          claimedAirdropList.map((item) => {
            return (
              <AirCard
                key={item.id}
                className={styles.card}
                turnOnAirDrop={turnOn}
                {...item}
              />
            );
          })
        ) : (
          <AirdropEmpty type="main" className={styles.empty} />
        )}
      </div>
    </div>
  );
};
